import { render, staticRenderFns } from "./DraftEmailPanel.vue?vue&type=template&id=ce2b5640&scoped=true"
import script from "./DraftEmailPanel.vue?vue&type=script&lang=js"
export * from "./DraftEmailPanel.vue?vue&type=script&lang=js"
import style0 from "./DraftEmailPanel.vue?vue&type=style&index=0&id=ce2b5640&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce2b5640",
  null
  
)

export default component.exports